export const enum AddEditFormType {
    ADD,
    EDIT
}